module.exports = __webpack_public_path__ + "static/media/dc.076ba310.svg";